{
  "notifications": {
    "invalidAisles": "allées non valides.  Changé pour la valeur du filtre par défaut",
    "invalidDepartments": "Départements non valides.  Changé pour la valeur du filtre par défaut",
    "invalidDepartments_lidl_gb": "Familles non valides.  Changé pour la valeur du filtre par défaut",
    "invalidDepartments_lidl_fr": "Familles non valides.  Changé pour la valeur du filtre par défaut",
    "invalidStore": "supermarché non valide.  Changé pour votre supermarché par defaut",
    "invalidTimeRange": "Période de temps non valide.  Changé pour les valeurs par défaut.",
    "storeAccessChanged": "L’accès au supermarché est changé.  Veuillez vous reconnecter."
  },
  "status": {
    "active": "actif",
    "inactive": "inactif",
    "deleted": "supprimé"
  },
  "loader": {
    "retry": {
      "message": "Échec de téléchargement..."
    }
  }
}
